<template>
  <label class="fc" :class="{ 'fc-inline': inline }">
    <span class="fc-label">{{ filter.label || filter.name }}</span>
    <select v-if="filter.type === 'choice'" :value="value" @change="$emit('change', $event.target.value)">
      <option value="">Any</option>
      <option v-for="o in filter.options || []" :key="o" :value="o">{{ o }}</option>
    </select>
    <input v-else-if="filter.type === 'year' || filter.type === 'number'" :value="value" type="number" @change="$emit('change', $event.target.value === '' ? '' : Number($event.target.value))">
    <span v-else-if="filter.type === 'entity'" class="fc-entity">
      <EntitySearch_Single button-text="Choose" modal-title="Choose an entity" button-class="fc-pick" @entity-selected="pick" />
      <span v-if="value" class="sensitive">{{ name || `Entity ${value}` }}</span>
      <button v-if="value" type="button" class="fc-clear" @click="$emit('change', ''); name = ''">Clear</button>
    </span>
    <input v-else-if="filter.type === 'date'" :value="value" type="date" @change="$emit('change', $event.target.value)">
    <input v-else :value="value" type="text" @change="$emit('change', $event.target.value)">
  </label>
</template>

<script>
import EntitySearch_Single from '@/components/widgetcomponents/Search_Widgets/EntitySearch_Single.vue';

export default {
  name: 'FilterControl',
  components: { EntitySearch_Single },
  props: {
    filter: { type: Object, required: true },
    value: { type: [String, Number, Object], default: '' },
    inline: { type: Boolean, default: false },
  },
  emits: ['change'],
  data() {
    return { name: '' };
  },
  methods: {
    pick(entity) {
      if (!entity) return;
      this.name = entity.name || entity.entity_name || '';
      this.$emit('change', Number(entity.id));
    },
  },
};
</script>

<style scoped>
.fc { display: flex; align-items: center; gap: 6px; font-size: 12px; color: #56534d; }
.fc-inline .fc-label { font-size: 12px; color: #A5A5A6; white-space: nowrap; }
.fc-entity { display: inline-flex; align-items: center; gap: 6px; }
.fc-clear { font-size: 11.5px; color: #626264; text-decoration: underline; }
.fc input, .fc select { font-size: 12.5px; padding: 4px 6px; border: 1px solid #dad8d2; border-radius: 6px; background: #fff; }
.fc-inline input, .fc-inline select { font-size: 12px; padding: 5px 8px; border-color: #e5e7eb; }
.fc input[type='number'] { width: 84px; }
</style>
